import React from "react";
import { Box } from '@mui/joy';
import { Bar } from 'src/mtska-frontend-app-component';
import { useTranslation } from 'react-i18next';
import KPIFunnelSet from "./IndicatoriDiSintesi.KPIFunnelSet";
import KPICostSet from "./IndicatoriDiSintesi.KPICostSet";
import KPIBudgetSet from "./IndicatoriDiSintesi.KPIBudgetSet";
import KPIMaturatoSet from "./IndicatoriDiSintesi.KPIMaturatoSet";

const IndicatoriDiSintesi = ({ dataProviderName, filters, $key }) => {
    const { t } = useTranslation();

    const showKPIFunnel = true;
    const showKPIBudget = true;
    const showKPICost = true;
    const showKPIMaturato = true;

    return (
        <Box className="dashboard-page" key={$key}>
            <Box className="dashboard-page-title">
                <h2>{t('Indicatori di Sintesi')}</h2>
            </Box>

            {showKPIFunnel &&
                <Box className="report-itemgroup">
                    <KPIFunnelSet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

            {showKPICost &&
                <Box className="report-itemgroup">
                    <KPICostSet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

            {showKPIBudget &&
                <Box className="report-itemgroup">
                    <KPIBudgetSet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

            {showKPIMaturato &&
                <Box className="report-itemgroup">
                    <KPIMaturatoSet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }
        </Box>
    )
}

export default IndicatoriDiSintesi;